import {createApp, nextTick} from "vue";
const axios = require('axios');

export default {
    name: 'vacancyForm',
    _el: null,
    init() {
        this._els = document.querySelectorAll('[data-vacancy-form]');
        for (const el of this._els) {
            this.run(el);
        }
    },

    run (element)
    {
        let firstName   = null;
        let lastName    = null;
        let email       = null;
        let mobile      = null;
        let message     = null;
        let gdpr        = false;

        const queryString = window.location.search;
        if (queryString.search('test=vacancy') != -1) {
            firstName = 'Ola';
            lastName = 'Nordmann';
            email = 'test@example.com';
            mobile = '12345679';
            message = 'Test :-)';
            gdpr = true;
        }

        createApp({
            delimiters: ['@{', '}'],
            data()  {
                return {
                    a           : 'vacancy form',
                    attachment  : null,
                    classAttachment  : '',
                    gdpr        : gdpr,
                    host        : '',
                    honeypot    : false,
                    redirect    : '',
                    firstName   : firstName,
                    lastName    : lastName,
                    userId      : email,
                    email       : '',
                    mobile       : mobile,
                    message     : message,
                    responseStatus : null,
                    responseMessage : null,
                    vacancyId   : '',
                    www         : null,
                    xhrActive   : false

                }
            },

            computed :
            {
                busy () {
                    return (this.xhrActive) ? ' busy ' : '';
                }
            },

            created()
            {
                this.host           = document.querySelector('[name="site_root"]').content;
                this.redirect       = window.location.href;

                this.vacancyId      = (Number.isInteger(parseInt(element.dataset.vacancyid))) ? element.dataset.vacancyid : "";
                nextTick(this.enableform);
            },

            methods:
            {
                enableForm() {
                    element.querySelector('.contact-form').classList.add('is-ready');
                },

                prepareData() {
                    const token = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');

                    const bodyFormData = new FormData();
                    bodyFormData.append('first_name', this.firstName);
                    bodyFormData.append('last_name', this.lastName);
                    bodyFormData.append('gdpr', (this.gdpr) ? '1' : '0');
                    bodyFormData.append('mobile', this.mobile);
                    bodyFormData.append('email', this.userId);
                    bodyFormData.append('honeypot', document.getElementById('email').value);
                    bodyFormData.append('message', this.message);
                    bodyFormData.append('vacancy_id', this.vacancyId);
                    bodyFormData.append('cv', this.attachment.files[0]);

                    return bodyFormData;
                },

                validateAttachment() {
                    this.attachment = this.$refs.attachment;
                    const file = this.$refs.attachment.files[0];
                    let status = true;

                    const limit = 1024 * 1024 * 5;
                    if (file && file.size > limit) {
                        status = false;
                        this.classAttachment = 'error';
                    }

                    return status;
                },

                onSubmit(event) {
                    this.responseStatus = '';
                    this.responseMessage = '';
                    this.classAttachment = '';

                    if (this.validateAttachment()) {
                        this.xhrActive = true;
                        const headers = { "Content-Type": "multipart/form-data" };
                        const postData = this.prepareData();
                        const url = this.host+'actions/mm/vacancy/store';

                        axios.post(url, postData, headers)
                            .then(this.onSubmit__callback)
                            .catch(this.onSubmit__error);
                    } else {
                        this.responseStatus = 'error';
                        this.responseMessage = 'CV-fila er for stor (maks 5 MB)';
                    }
                },

                onSubmit__callback(response) {
                    if (typeof response === 'object' && typeof response.data === 'object') {
                        this.responseStatus = 'ok';
                        this.responseMessage = response.data.message;
                    }

                    this.xhrActive = false;
                },

                onSubmit__error(error) {

                    this.responseStatus = 'error';
                    this.responseMessage = error;
                }
            }
        }).mount(element);

    }
}